import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TermsAndConditions = () => {
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/site-content/terms_full`);
        setDoc(Array.isArray(res.data) ? res.data[0] : res.data);
      } catch (e) {
        console.error('Failed to load T&C:', e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return (
    <div className="bg-sand min-h-screen pt-20" data-testid="terms-page">
      {/* Header */}
      <section className="py-20 md:py-28 px-4 bg-navy">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <span className="font-accent text-xs uppercase tracking-[0.3em] text-gold/80 mb-4 block">
              JMD Wildlife • Legal
            </span>
            <h1 className="font-heading text-5xl md:text-7xl font-light text-gold mb-6 leading-[0.95]">
              {doc?.title || 'Terms & Conditions'}
            </h1>
            <p className="font-body text-base md:text-lg text-sand/80 max-w-2xl mx-auto leading-relaxed">
              Please read these terms carefully before booking your safari with JMD Wildlife.
              Confirming a booking implies acceptance of all the terms outlined below.
            </p>
          </motion.div>
        </div>
      </section>

      <div className="max-w-5xl mx-auto px-4 pt-8">
        <Link
          to="/"
          data-testid="back-home-link"
          className="inline-flex items-center space-x-2 text-navy hover:text-emerald-700 transition-colors"
        >
          <ArrowLeft size={18} />
          <span className="font-body">Back to Home</span>
        </Link>
      </div>

      <section className="py-12 md:py-16 px-4">
        <div className="max-w-4xl mx-auto">
          {loading ? (
            <p className="font-body text-center text-muted-foreground py-20">Loading…</p>
          ) : doc ? (
            <div
              className="bg-white rounded-xl shadow-md p-6 md:p-12 border border-emerald-100 markdown-legal"
              data-testid="terms-content"
            >
              <ReactMarkdown>{doc.content}</ReactMarkdown>
            </div>
          ) : (
            <p className="font-body text-center text-muted-foreground py-20">
              Terms & Conditions unavailable. Please contact us directly.
            </p>
          )}
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
